import {
  createSharedOptionCategoryMutationOptions,
  deleteSharedOptionCategoryMutationOptions,
  sharedOptionCategoriesHistoryQueryOptions,
  sharedOptionCategoriesQueryOptions,
  sharedOptionCategorySelectOptionsQueryOptions,
  updateSharedOptionCategoryMutationOptions,
} from "../api/enterpriseCustomerOptionCategories";
import type { OptionCategoryScope } from "../optionCategoryList/optionCategoryScopes";
import { customerOptionCategoryToSlug } from "../shared/usePrivacyNavigate";

export const sharedOptionCategoryScope: OptionCategoryScope = {
  name: "customer",
  routePath: categoryType => `customer/option-categories/${customerOptionCategoryToSlug[categoryType]}`,
  listQueryOptions: sharedOptionCategoriesQueryOptions,
  historyQueryOptions: sharedOptionCategoriesHistoryQueryOptions,
  selectOptionsQueryOptions: sharedOptionCategorySelectOptionsQueryOptions,
  createMutationOptions: createSharedOptionCategoryMutationOptions,
  updateMutationOptions: updateSharedOptionCategoryMutationOptions,
  deleteMutationOptions: deleteSharedOptionCategoryMutationOptions,
  permission: () => "nova-forms-api:enterprise-customers:option-categories:manage",
  hasDescription: () => true,
  usageLinkTo: undefined,
};
